import IconPhone from '../../../../../images/icon-phone.svg';
import IconGlobe from '../../../../../images/icon-globe.svg';
import IconInstagram from '../../../../../images/icon-instagram.svg';
import IconFacebook from '../../../../../images/icon-facebook.svg';
import { t } from '../../i18n';
import {getAssetLink} from '../../../../helpers/api';

export const buildRoute = (activeMarker, userCoordinates) => {
  const baseUrl = 'https://www.google.com/maps/dir';
  const { position } = activeMarker;
  const userLatLng = userCoordinates ? [userCoordinates.latitude, userCoordinates.longitude].join(',') : '';
  const targetLatLng = position ? [position.lat(), position.lng()].join(',') : '';

  return `${baseUrl}/${userLatLng}/${targetLatLng}`;
}

export const getTitleFragment = (item) => {
  const title = item?.info?.displayName || item?.info?.name || '';

  return title ? `<p class="title text-bold">${title}</p>` : '';
}

export const getImageFragment = (activeMarker, defaultStoreImage) => {
  const assetLink = getAssetLink(activeMarker?.info?.image) || defaultStoreImage;

  return assetLink ? `<img class="store-image" src="${assetLink}" alt="">` : '';
}

export const getBrandFragment = (item) => {
  const isEquipe = item?.info?.equipe;
  const isAmerigo = item?.info?.amerigo;

  return `
    <div class="brand-list">
      ${isEquipe ? '<span class="brand equipe">equipe</span>' : ''}
      ${isAmerigo ? '<span class="brand amerigo">amerigo</span>' : ''}
    </div>
  `;
}

export const getAddressFragment = (item, layout = 'two_line') => {
  const {
    street = '',
    zipCode = '',
    city = '',
    country = ''
  } = item.info;
  const hasContent = street || zipCode || city || country;

  if (!hasContent) {
    return '';
  }

  if (layout === 'one_line') {
    return `
      <div class="address">
        <p>${street} ${city} ${zipCode} ${country}</p>
      </div>
    `;
  }

  return `
    <div class="address">
      <p>${street}</p>
      <p>${city} ${zipCode} ${country}</p>
    </div>
  `;
}
export const getTopFragment = (item) => {
  const top = item?.info?.top || '';

  return top ? '<span class="tag">TOP</span>' : '';
};

export const getStoreTypeFragment = (item) => {
  const storeType = item?.info?.storeType || '';
  const storeTypeTranslated = t(storeType);

  return storeType ?
    `<div class="flex-container align-right">
      <span class="store-type">${storeTypeTranslated}</span>
    </div>` :
    '';
}

export const getPhoneFragment = (item) => {
  const phone = item?.info?.phone || '';

  return phone ?
    `<a href="tel:${phone}" class="margin-bottom-1">
      <img src="${IconPhone}" alt="">
      ${phone}
    </a>` :
    '';
}

export const getWebsiteFragment = (item) => {
  const website = item?.info?.websiteURL || '';

  return website ?
    `<a href="${website}" target="_blank">
      <img src="${IconGlobe}" alt="">
      ${website}
    </a>` :
    '';
}

export const getSocialsFragment = (item, followUsLabel) => {
  const instagram = item?.info?.instagramURL || '';
  const facebook = item?.info?.facebookURL || '';
  const hasContent = instagram || facebook;

  return hasContent ? `
    <p class="socials">
      <span>
        ${followUsLabel}
      </span>
      ${instagram && `
        <span>
          <a href="${instagram}" target="_blank">
            <img src="${IconInstagram}" alt="Follow us on Instagram">
          </a>
        </span>
      `}
      ${facebook && `
        <span>
          <a href="${facebook}" target="_blank">
            <img src="${IconFacebook}" alt="Follow us on Facebook">
          </a>
        </span>
      `}
    </p>
  ` : '';
}

export const getDistanceFragment = (item) => {
  const distance = item?.info?.distance;
  
  if (!distance) {
    return '';
  }

  const roundedDistance = Math.round(distance * 10) / 10; // Round to 1 decimal place
  
  return `
    <div class="distance">
      <span class="distance-value">${roundedDistance} km</span>
    </div>
  `;
}
